import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
import { ENV } from '../../../config/config';
import api from '../../../config/axios-instance';



/**
 * AccoutPopover Component
 *
 * All rights | ArhamSoft Pvt @2023
 *
 * @returns {JSX.Element} -JSX representation of the component.
 *
 */

export default function AccountPopover() {
    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem('token'));
    const userId = JSON.parse(localStorage.getItem('userId'));
    const [profileData, setProfileData] = useState(null); // Initialize to null
    const [open, setOpen] = useState(null);

    const MENU_OPTIONS = [
        {
            label: 'Profile', 
        },
    ];
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const fetchData = async () => {
        try {
            const response = await api.get(`${ENV.appBaseUrl}/user/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setProfileData(response.data?.user);
        } catch (error) {
            toast.error(error?.message);
        }
    };

    // useEffect(() => {
    //     fetchData();
    // }, []);

     /**
     * Close the popover menu and navigate based on the label
     *
     */
    //  const handleClose = (label) => {
    //     setOpen(null);
    //     let destination = '/dashboard/profile'; // Default to the profile path
    //     if (label === 'logout') {
    //         destination = '/dashboard/logout'; 
    //     }
    //     setTimeout(() => {
    //         navigate(destination);
    //     }, 500);
    // };

    const handleClose = (label) => {
        setOpen(null);
        if (label === 'Profile') {
            setTimeout(() => {
                navigate('/dashboard/profile');
        }, 500);
        }
    };
    


    const handleLogout = async () => {
     try 
     {
      setOpen(null);
      const response = await api.post('/lender/logout');
      localStorage.removeItem('token');
      navigate('/login');
    } catch (error) {
      navigate('/login');
    }
    };

    

    return (
        <>
            <IconButton
                onClick={handleOpen}
                sx={{
                    p: 0,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
                        },
                    }),
                }}
            >
                <Avatar className='profile-img' src={`${ENV.file_Url}/${profileData?.profileImage}`} alt={profileData?.name} />
            </IconButton>
            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 0,
                        mt: 1.5,
                        ml: 0.75,
                        width: 180,
                        '& .MuiMenuItem-root': {
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {profileData?.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                        {profileData?.email}
                    </Typography>
                </Box>
                {/* <Divider sx={{ borderStyle: 'dashed' }} />
                <Stack sx={{ p: 1 }}>
                    {MENU_OPTIONS.map((option) => (
                        <MenuItem key={option.label} onClick={() => handleClose(option.label)}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Stack>
                <Divider sx={{ borderStyle: 'dashed' }} /> */}
                <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
                    Logout
                </MenuItem>
            </Popover>
        </>
    );
}
